import { Navigate, RouteObject } from 'react-router-dom';
import {
  CONFIGS_COMPARE_PATH
, CONFIGS_HISTORY_PATH
, CONFIGS_PATH
, DEPLOYMENTS_CREATE_PATH
, DEPLOYMENTS_PATH
, DEPLOYMENTS_VIEW_PATH
, SCHEMAS_PATH
, SERVER_DETAILS_PATH
, SERVERS_PATH
} from './appPaths';
import DeploymentsView from '../views/deployments/DeploymentsView';
import ServerListView from '../views/servers/ServerListView';
import ServerDetailsView from '../views/servers/ServerDetailsView';
import ConfigsView from '../views/configurations/ConfigsView';
import SchemasView from '../views/schemas/SchemasView';
import DeploymentListView from '../views/deployments/DeploymentListView';
import NewDeploymentView from '../views/deployments/NewDeploymentView';
import ConfigsHistoryView from '../views/configurations/ConfigsHistoryView';
import ConfigsCompareView from '../views/configurations/ConfigsCompareView';

export const appRoutes: RouteObject[] = [
  { path: '/', element: <Navigate to={SERVERS_PATH} /> },
  { path: SERVERS_PATH, element: <ServerListView /> },
  { path: SERVER_DETAILS_PATH, element: <ServerDetailsView /> },
  { path: CONFIGS_PATH, element: <ConfigsView /> },
  { path: CONFIGS_HISTORY_PATH, element: <ConfigsHistoryView /> },
  { path: CONFIGS_COMPARE_PATH, element: <ConfigsCompareView /> },
  { path: SCHEMAS_PATH, element: <SchemasView /> },
  { path: DEPLOYMENTS_PATH, element: <DeploymentsView /> },
  { path: DEPLOYMENTS_VIEW_PATH, element: <DeploymentListView /> },
  { path: DEPLOYMENTS_CREATE_PATH, element: <NewDeploymentView /> },
];
